import React, { useEffect, useState } from 'react';
import { MapPin, CheckCircle2 } from 'lucide-react';
const names = ['Martín Gómez', 'Carolina Pereyra', 'Diego Fernández', 'Lucía Sosa', 'Federico Álvarez', 'Juan Martínez', 'Agustín Rodríguez', 'Tomás López', 'Julieta Vázquez', 'Emiliano Castro', 'Sofía Romero', 'Nicolás Benítez', 'Mariano Suárez', 'Valentina Ríos', 'Sebastián Molina', 'Camila Herrera', 'Joaquín Paz', 'Florencia Acosta'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bariloche', 'Santa Fe', 'San Juan', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná', 'Corrientes', 'Río Cuarto'];
const buyers = names.map((name, i) => ({
  name,
  city: cities[i % cities.length]
}));
export const PurchasePopup = () => {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setBuyer(randomBuyer);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 12000);
    // Recurring
    const interval = setInterval(showPopup, 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 bg-white text-navy-900 p-4 rounded-xl shadow-2xl z-50 flex items-start gap-4 max-w-[320px] border-l-4 border-rugby-blue transition-all duration-500 ease-in-out transform translate-y-0 opacity-100" data-id="element-157">
      <div className="bg-blue-50 p-2 rounded-full mt-1" data-id="element-158">
        <CheckCircle2 className="w-6 h-6 text-rugby-blue" data-id="element-159" />
      </div>
      <div data-id="element-160">
        <p className="text-sm font-bold text-navy-900" data-id="element-161">
          {buyer.name} de {buyer.city}
        </p>
        <p className="text-xs text-slate-600 mt-0.5 leading-tight" data-id="element-162">
          Acaba de comprar el sistema Rugby Infantil 360
        </p>
        <div className="flex items-center gap-1 mt-2" data-id="element-163">
          <MapPin className="w-3 h-3 text-slate-400" data-id="element-164" />
          <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider" data-id="element-165">
            Hace unos minutos
          </p>
        </div>
      </div>
    </div>;
};